<template>
    <form-row title="Listing Source">
        <input-radio-multi
            name="listing_source"
            :value="listing_detail.listing_source"
            :options="[
                { label: 'Personal', value: 'personal' },
                { label: 'Other Broker', value: 'other_broker' },
                { label: 'Re-lo', value: 'relo' },
            ]"
            :nullable="true"
            :read_only="read_only"
        />
    </form-row>
</template>

<script>
export default {
    props: {
        listing_detail: { default: () => ({}) },
        read_only: { default: false },
    },
}
</script>
